import {
  AmendHousekeepingPlanRequest,
  CreateHousekeepingPlanRequest,
  CreateHousekeepingPlanResponse,
  HousekeepingPlanResponse,
  HousekeepingPlansApi,
  HousekeepingPlanSummaryResponse,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class HousekeepingPlanService {
  private readonly httpClient = createApiClient(HousekeepingPlansApi)

  // L2.3 returns a wrapper: `plan` is null when every accumulated container
  // was race-dropped between accumulation and Confirm, and `droppedContainerIds`
  // is the list of containers the caller should surface as an inline warning.
  async createPlan(request: CreateHousekeepingPlanRequest): Promise<CreateHousekeepingPlanResponse> {
    const { data } = await this.httpClient.createHousekeepingPlan(request)
    return data
  }

  async getPlans(ids?: string[]): Promise<HousekeepingPlanSummaryResponse[]> {
    const { data } = await this.httpClient.getHousekeepingPlans(
      ids && ids.length > 0 ? ids : undefined,
    )
    return data
  }

  async getPlanById(id: string): Promise<HousekeepingPlanResponse> {
    const { data } = await this.httpClient.getHousekeepingPlanById(id)
    return data
  }

  async amendPlan(
    id: string,
    request: AmendHousekeepingPlanRequest,
  ): Promise<HousekeepingPlanResponse> {
    const { data } = await this.httpClient.amendHousekeepingPlan(id, request)
    return data
  }

  async cancelPlan(id: string): Promise<HousekeepingPlanResponse> {
    const { data } = await this.httpClient.cancelHousekeepingPlan(id)
    return data
  }
}

export const housekeepingPlanService = new HousekeepingPlanService()
